module.exports = __webpack_public_path__ + "static/media/img03.9e58d6bc.webp";